import { render, staticRenderFns } from "./KpiList.vue?vue&type=template&id=a35029a6&scoped=true"
import script from "./KpiList.vue?vue&type=script&lang=js"
export * from "./KpiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35029a6",
  null
  
)

export default component.exports